import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { __API_URL__ } from "../SERVER_URL";

const fetchVisitsStatusDowndown = async ({ trialId, patientId }) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();
  if (!!patientId) params.append("patient_id", patientId);

  const URL = `${__API_URL__}/api/photos/get_visits_dropdown_status/${trialId}/?${params.toString()}`;

  const res = await axios.get(URL, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return res.data;
};

const useGetVisitsDropdownStatus = ({ trialId, patientId, enabled = true }) => {
  return useQuery({
    queryKey: ["visits_status_dropdown", trialId, patientId],
    queryFn: () => fetchVisitsStatusDowndown({ trialId, patientId }),
    enabled: enabled && Boolean(trialId && trialId > 0),
  });
};

export default useGetVisitsDropdownStatus;
